import React, { useState, useContext, useRef } from "react";
import { 
    Page, 
    Text, 
    Spacer, 
    Button, 
    Input, 
    Grid, 
    useTheme, 
    Divider, 
    Checkbox,
    Note,
    Loading
} from "@geist-ui/core";
import { useMediaQuery } from "@mui/material";
import { Mail, Lock, User, Phone, Check, ArrowRight, Shield, LogIn } from "@geist-ui/icons";
import { useForm, Controller } from "react-hook-form";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Cookies from "js-cookie";
import ReCAPTCHA from "react-google-recaptcha";
import API_CLIENT from "../../../utility/api-client";
import { SignupData } from "../../../types/onboarding_types";
import { SALUTATION, TITLE } from "../../../types/inventure-user_types";
import Normalizer from "../../../utility/normalizer";
import { AppContext } from "../direct-router";
import { BrandLogo } from "../../../components/brand-logo";
import { motion } from "framer-motion";
import { GeistHookFormInput } from "../investment-process-v2/components/geist-form-inputs";
import { isNativePlatform } from "../../../utils/platform";

export default function FastAuth() {
    const history = useHistory();
    const location = useLocation();
    const { loginWithRedirect } = useAuth0();
    const [error, setError] = useState<string | null>(null);

    const handleGoogleAuth = async () => {
        try {
            await loginWithRedirect({
                authorizationParams: {
                    connection: 'google-oauth2',
                },
                appState: {
                    returnTo: '/direct/dashboard'
                }
            });
        } catch (err: any) {
            console.error('Google auth failed:', err);
             setError(`Login fehlgeschlagen: ${err.message || 'Unbekannter Fehler'}`);
        }
    };

    const isMobile = useMediaQuery('(max-width:900px)');

    return (
        <div style={{ display: 'flex', minHeight: '100vh', width: '100%', background: '#fff', overflow: 'hidden', flexDirection: isMobile ? 'column' : 'row' }}>
            {/* Left Column: Form */}
            <div style={{ 
                flex: isMobile ? '1 1 auto' : '0 0 620px', 
                padding: isMobile ? '32px 24px' : '60px 80px', 
                position: 'relative', 
                zIndex: 10, 
                background: '#fff', 
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center' 
            }}>
                <div style={{ position: 'absolute', bottom: '-40px', left: '-40px', zIndex: -1, opacity: 0.05, fontFamily: 'Nunito Sans, sans-serif', userSelect: 'none', pointerEvents: 'none' }}>
                    <div style={{ fontSize: '320px', fontWeight: 900, letterSpacing: '-0.05em', lineHeight: 0.8, color: '#000' }}>inventure.</div>
                </div>

                <div style={{ maxWidth: '440px', width: '100%' }}>
                    <div style={{ marginBottom: '80px' }}>
                        <BrandLogo fontSize="32px" onClick={() => history.push("/")} style={{ cursor: 'pointer' }} />
                    </div>

                  
                    <Text h1 style={{ fontSize: '48px', fontWeight: 900, letterSpacing: '-0.04em', lineHeight: 1.1, marginBottom: '40px', fontFamily: "'Nunito Sans', sans-serif" }}>
                        <><i style={{ fontStyle: 'italic' }}>Willkommen.</i></>
                    </Text>

                    <div style={{ width: '100%' }}>
                        <Grid.Container gap={1.5}>
                            {error && (
                                <Grid xs={24}>
                                    <Note type="error" style={{ width: '100%' }}>{error}</Note>
                                </Grid>
                            )}

                            <Grid xs={24}>
                                <Button 
                                    onClick={handleGoogleAuth} 
                                    width="100%" 
                                    height="56px" 
                                    style={{ borderRadius: '100px', background: '#fff', color: '#000', border: '1px solid #e2e2e2', fontWeight: 700, fontSize: '16px' }} 
                                    icon={<svg width="18" height="18" viewBox="0 0 18 18" style={{ marginRight: '8px' }}><path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/><path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/><path d="M3.964 10.706A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.04l3.007-2.334z" fill="#FBBC05"/><path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.962l3.007 2.332c.708-2.127 2.692-3.713 5.036-3.713z" fill="#EA4335"/></svg>}
                                >
                                    Mit Google fortfahren
                                </Button>
                            </Grid>

                            <Grid xs={24}>
                                <div style={{ display: 'flex', alignItems: 'center', margin: '16px 0' }}>
                                    <div style={{ flex: 1, height: '1px', background: '#eaeaea' }}></div>
                                    <div style={{ flex: 1, height: '1px', background: '#eaeaea' }}></div>
                                </div>
                            </Grid>

                            <Grid xs={24}>
                                <div style={{ marginTop: '0px', display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                                    <Button 
                                        onClick={() => {
                                             loginWithRedirect({
                                                authorizationParams: {
                                                    screen_hint: 'signup',
                                                },
                                                appState: {
                                                    returnTo: '/direct/dashboard'
                                                }
                                            });
                                        }} 
                                        type="secondary" 
                                        style={{ width: '100%', borderRadius: '100px', fontWeight: 800, height: '60px', background: '#000', color: '#fff', fontSize: '16px', letterSpacing: '-0.01em' }} 
                                    >
                                        Account erstellen
                                    </Button>
                                    
                                    <Button 
                                        onClick={() => {
                                             loginWithRedirect({
                                                authorizationParams: {
                                                    screen_hint: 'login',
                                                },
                                                appState: {
                                                    returnTo: '/direct/dashboard'
                                                }
                                            });
                                        }} 
                                        style={{ width: '100%', borderRadius: '100px', fontWeight: 700, height: '60px', background: 'transparent', color: '#000', border: '1px solid #e2e2e2', fontSize: '15px' }}
                                    >
                                        Bereits Mitglied? Hier einloggen
                                    </Button>
                                </div>
                            </Grid>
                        </Grid.Container>
                    </div>
                </div>
            </div>

            {/* Right Column: Branding */}
            {!isMobile && (
            <div style={{ flex: 1, background: '#000', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '80px', textAlign: 'center', position: 'relative' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.15 }}>
                    <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0 100 L100 0 L100 100 Z" fill="url(#gradAuth)" /><defs><linearGradient id="gradAuth" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style={{ stopColor: '#333' }} /><stop offset="100%" style={{ stopColor: '#000' }} /></linearGradient></defs></svg>
                </div>
                
                <div style={{ position: 'relative', zIndex: 10, width: '100%', maxWidth: '540px' }}>
                    {/* Liquid Ambient Glows */}
                    <motion.div 
                        animate={{ 
                            x: [-30, 30, -30],
                            y: [-30, 30, -30],
                            scale: [1, 1.2, 1],
                        }}
                        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
                        style={{
                            position: 'absolute',
                            top: '-20%',
                            right: '-20%',
                            width: '400px',
                            height: '400px',
                            background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                            filter: 'blur(60px)',
                            zIndex: -1
                        }}
                    />
                </div>
            </div>
            )}
        </div>
    );
}
